import { createSlice } from '@reduxjs/toolkit';
import { PRIVILEGED_ROLES } from '../../utils/constants/roles';
import { ROLES } from '../../utils/constants/roles';

function safeParseJSON(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Failed to parse JSON:', error);
    return null;
  }
}
const initialState = {
  userSession: JSON.parse(localStorage.getItem('userSession')) || null,
  isAuthenticated: JSON.parse(localStorage.getItem('isAuthenticated')) || false,
  isOnboardingComplete: JSON.parse(localStorage.getItem('isOnboardingComplete')) || false,
  venue: JSON.parse(localStorage.getItem('venue')) || null,
  employeeInfo: JSON.parse(localStorage.getItem('employeeInfo')) || null,
  role: safeParseJSON(localStorage.getItem('role')) || null,
};

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setUserSession: (state, action) => {
      state.userSession = action.payload;
      state.isAuthenticated = !!action.payload; // Mark as authenticated if there is a session

      // Save to localStorage
      localStorage.setItem('userSession', JSON.stringify(action.payload));
      localStorage.setItem('isAppleAuthenticated', JSON.stringify(!!action.payload));
    },
    setUserProfileImage(state, action) {
      const { profileImageUrl } = action.payload;

      // Update employeeInfo
      state.employeeInfo = {
        ...state.employeeInfo,
        profileImageUrl, // Overrides the profileImageUrl field
      };

      // Update currentUser if it exists
      if (state.currentUser) {
        state.currentUser = {
          ...state.currentUser,
          employeeInfo: {
            ...state.currentUser.employeeInfo,
            profileImageUrl, // Updates only the profileImageUrl field
          },
        };
      }
    },
    setOnboardingComplete: (state) => {
      state.isOnboardingComplete = true; // Update the status of the onboarding flow
      localStorage.setItem('isOnboardingComplete', 'true');
    },
    setVenueInfo: (state, action) => {
      state.venue = action.payload;
      // Save to localStorage
      localStorage.setItem('venue', JSON.stringify(action.payload));
    },
    setEmployeeInfo: (state, action) => {
      state.employeeInfo = action.payload;
      state.isUnionVerified = true;
      // Save to localStorage
      localStorage.setItem('employeeInfo', JSON.stringify(action.payload));
      localStorage.setItem('isUnionVerified', JSON.stringify(true));
      localStorage.setItem('isAuthenticated', JSON.stringify(true));
    },
    setRole: (state, action) => {
      state.role = action.payload;
      // Save to localStorage
      localStorage.setItem('role', JSON.stringify(action.payload));
    },
    logoutUser: (state) => {
      Object.assign(state, {
        userSession: null,
        isAuthenticated: false,
        isOnboardingComplete: false,
        venue: null,
        employeeInfo: null,
        role: null,
      });

      // Clear localStorage
      localStorage.clear();
    },
  },
});

export const {
  setUserSession,
  setOnboardingComplete,
  setVenueInfo,
  setEmployeeInfo,
  logoutUser,
  setUserProfileImage,
  setRole,
} = currentUserSlice.actions;

export const selectCurrentVenue = (state) => state.currentUser.venue;
export const selectCurrentEmployee = (state) => state.currentUser.employeeInfo;
export const selectCurrentRole = (state) => state.currentUser.role;
export const selectHasPrivilegedRole = (state) => PRIVILEGED_ROLES.includes(state.currentUser.role);
export const selectCurrentUserId = (state) => state.currentUser.employeeInfo?.id;
export const selectIsCurrentUserOwner = (state) => state.currentUser.role === ROLES.OWNER;

export default currentUserSlice.reducer;
